import { useNavigate } from 'react-router-dom'

import { Box, type MediumIcon, Row, Title } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/compensations/pages/settings/ConnectedModules/_Item'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export interface ModuleConfig {
  key: string
  titleKey: string
  illustration: MediumIcon
  navigationPath: string
}

interface Props {
  modules: ModuleConfig[]
  canUpsellPayroll?: boolean
}

const Content = ({ modules, canUpsellPayroll }: Pick<Props, 'modules' | 'canUpsellPayroll'>) => {
  const navigate = useNavigate()

  const handleModuleClick = (navigationPath: string) => {
    if (canUpsellPayroll) {
      return
    }
    navigate(navigationPath)
  }

  const getModuleTitle = (titleKey: string): string => {
    switch (titleKey) {
      case 'compensations.settings.connected_modules.expenses':
        return i18n.t('compensations.settings.connected_modules.spending')
      case 'compensations.settings.connected_modules.time_tracking':
        return i18n.t('compensations.settings.connected_modules.time_tracking')
      case 'compensations.settings.connected_modules.benefits.title':
        return i18n.t('compensations.settings.connected_modules.benefits.title')
      default:
        return titleKey
    }
  }

  return (
    <Box
      component="ul"
      borderRadius={{ all: 'abs016' }}
      background="grey000White"
      border={{
        all: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
    >
      {modules.map((module) => (
        <Item
          key={module.key}
          onClick={() => handleModuleClick(module.navigationPath)}
          title={getModuleTitle(module.titleKey)}
          illustration={module.illustration}
          disabled={canUpsellPayroll}
        />
      ))}
    </Box>
  )
}

const ConnectedModules = ({ modules, canUpsellPayroll }: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" paddingX="s64" paddingY="s32" width="full">
      <Row>
        <Row.Col halfWidth>
          <Box paddingRight="s64">
            <Title
              variant="500"
              title={i18n.t('compensations.settings.connected_modules.title')}
              description={i18n.t('compensations.settings.connected_modules.description')}
              illustration={'URL'}
            />
            {canUpsellPayroll && (
              <UpsellingKit.UpsellButton
                moduleRequested={AvailableModules.compensations}
                requestSource="connected_modules_settings_page"
                pageSource="connected_modules_settings_page"
                requestReason={ValidReasons.MissingAddon}
                showModuleModal
                size="md"
                label={i18n.t('compensations.upsell_button')}
                variant="outlinePromote"
              />
            )}
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          <Content modules={modules} canUpsellPayroll={canUpsellPayroll} />
        </Row.Col>
      </Row>
    </Box>
  )
}

export default ConnectedModules
